module.exports = __webpack_public_path__ + "assets/images/pages/job/trainee-graphic-designer.png?6f13a560";